// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Alert, Base } from '@gandi/ui';

export function ResellerOnlyAlert(): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <Base marginBottom="small">
      <Alert
        message={__(
          'Your cart contains products that were bought at Gandi through a reseller. ' +
            'Only resellers can be billed for shopping carts containing such products.',
        )}
        intent="info"
      />
    </Base>
  );
}
